(function ($) {
    var _duration = 1000,
        _easing = "easeOutCubic",
        _width = window.innerWidth,
        _windowWidth = window.innerWidth,
        _windowHeight = window.innerHeight,
        _spmode = 768,
        _speed = 1000;
    _winScrollTop = 0;


    window.onload = function () {
        createGallerySlider();
        handleRelated();
        handleProductSliders();
        addImageClass();
        hideEmptyRelated();

    };
    window.onresize = function () {
        initPrdSlides();
    };
    

    async function createGallerySlider() {
        const galleries = $('.gallery');
    
        for (const gallery of galleries) {
            const $gallery = $(gallery);
            const imgs = $gallery.find('img');
            const imageList = [];
    
            imgs.each(function () {
                imageList.push(this.outerHTML);
            });
    
            if (imageList.length > 0) {
                const engine = new liquidjs.Liquid();
                engine.registerFilter('money_without_currency', price => {
                    return Number(price).toLocaleString();
                });
    
                const html = await engine.renderFile(blogGalleryTpl, {
                    gallery: imageList,
                });
    
                $gallery.html(html);
            }
        }
    
        initGallerySliders();
    }
    
    function initGallerySliders() {
        $('.gallery').each(function () {
            const $master = $(this).find('.slide_master');
            const $small = $(this).find('.slide_small');
            const $prev = $(this).find('.btn_prev');
            const $next = $(this).find('.btn_next');
            slickSlider($master, {
                asNavFor: $small,
                fade: false,
                autoplay: false,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: $prev,
                nextArrow: $next,
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            centerPadding: '0',
                        }
                    }
                ]
            });
            slickSlider($small, {
                asNavFor: $master,
                fade: false,
                autoplay: false,
                infinite: true,
                arrows: false,
                dots: false,
                adaptiveHeight: true,
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            centerPadding: '0',
                        }
                    }
                ]
            });
        })
    }
    async function handleRelated() {
        $('#postList li a').each(async function () {
            const handle = decodeURIComponent($(this).attr('href').split('/').pop());
            const result = await Article.getArticleByHandle('news', handle);
            const tag = result?.blogByHandle?.articleByHandle?.tags?.[0];
            if (tag) {
                $(this).find('.right_content').prepend('<span class="tag">' + tag + '</span>');
            }
        });


    }
    async function handleProductSliders() {
        const sliders = $('.prod_slide').toArray();

        for (const slider of sliders) {
            const $slider = $(slider);
            const handleArr = JSON.parse($slider.attr('data-handles'));
            const results = [];

            for (const handle of handleArr) {
                const product = await Product.getProductByHandle(handle);
                if (product) {
                    results.push(product);
                }
            }

            const engine = new liquidjs.Liquid();
            engine.registerFilter('money_without_currency', price => {
                return Number(price).toLocaleString();
            });

            // Await the template rendering and use 'results' instead of 'product'
            const html = await engine.renderFile(prodSlideTpl, {
                products: results,
                custom_class: 'slide_item'
            });

            $slider.html(html);
            initPrdSlides();
        }
    }
    function initPrdSlides(){
        const sliders = $('.prod_slide').toArray();
        for (const slider of sliders) {
            const $slider = $(slider);
            // Slider Init
            const $sliderList = $slider.find('.slide');
            const $prev = $slider.find('.btn_prev');
            const $next = $slider.find('.btn_next');


            slickSlider($sliderList, {
                fade: false,
                autoplay: false,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                variableWidth: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: $prev,
                nextArrow: $next,
                responsive: [
                    {
                        breakpoint: 961,
                        settings: "unslick"
                    }
                ]
            });
            if ($(window).width() < 769) {
                $sliderList.slick('unslick');
            }
            // Hide arrows if less than 4 slides
            if ($sliderList.slick('getSlick').slideCount <= 4) {
                $sliderList.addClass('no_arrow');
                $sliderList.slick('unslick');
                $prev.hide();
                $next.hide();
            }
        }

    }
    function addImageClass(){
        $('.blog_content p').each(function () {
            const children = $(this).children();
        
            if (children.length === 1 && children.prop('tagName').toLowerCase() === 'img') {
                $(this).addClass('has_image');
            }
        });
    }
    function hideEmptyRelated(){
        if ($('#postList').length && $('#postList').is(':empty')) {
            $('#postList').parents('.shopify-section').hide();
        }}
})(jQuery);
